import { useApiQuery } from '../api';
import { useTeam } from '../hooks';
import { day } from '@vrplatform/utils';
import { useMemo } from 'react';

type Props = {
  range: 'year' | 'month' | undefined;
};

export const useJournalEntriesMinMaxQuery = ({ range }: Props) => {
  const [{ id: teamId, effectiveStatementStartAt }] = useTeam();

  const queryData = useApiQuery(
    async (api, signal) => {
      const result = await api.GET('/reports/journal-entries', {
        params: {
          query: {
            limit: 1,
          },
        },
        signal,
      });

      if (result.error) throw result.error;

      return {
        maxDate: result.data.data?.[0]?.txnAt,
      };
    },
    {
      queryGroup: 'reports',
      uniqueQueryKey: 'profit-and-loss-years-filter',
      variables: {
        teamId,
      },
      keepPreviousData: true,
    }
  );

  const maxDate = queryData.data?.maxDate;

  const data = useMemo(() => {
    if (!range) {
      return {
        minDate: day(effectiveStatementStartAt).yyyymmdd(),
        maxDate: day(maxDate).yyyymmdd(),
      };
    }

    return {
      minDate: day(effectiveStatementStartAt).startOf(range).yyyymmdd(),
      maxDate: day(maxDate).endOf(range).yyyymmdd(),
    };
  }, [range, effectiveStatementStartAt, maxDate]);

  return {
    ...queryData,
    data,
  };
};
